import NoContentForFullScreen from "./NoContentForFullScreen"
import RowSpacer from "./styles/RowSpacer";

const NotFound = () => {
    return (
        <>
            <RowSpacer/>
            <NoContentForFullScreen message='없는 페이지에요'/>
            <RowSpacer/>
        </>
    )
}

export default NotFound